const setForm = (form) => {
  let fields = {
    signUp: {
      username: {
        required
      },
      email: {
        email
      },
      telephone: {
        minLength: minLength(3)
      },    
      firstname: {
        required,
        minLength: minLength(3)
      },
      lastname: {
        required,
        minLength: minLength(3)
      },
      password: {
        required,
        minLength: minLength(3)
      },
      mpassword: {
        required,
        minLength: minLength(3),
        sameAsPassword: sameAs('password')
      }, 
      tnc: {
        required
      }
    },
    verifyNumber: {     
      code: {
        required
      }
    },
    recoverPassword: {     
      username: {
        required
      }
    },
    recoverPassword: {     
      username: {
        required
      }
    },
    recoverPasswordSendCode: {     
      code: {
        required
      },
      password: {
        required
      },
      mpassword: {
        required,
        minLength: minLength(3),
        sameAsPassword: sameAs('password')
      },      
    },    
    auth: {
      username: {
        required
      },
      password: {
        required,
        minLength: minLength(3)
      }
    }
  }
  return fields[form]
}

import { validationMixin } from 'vuelidate'
import {
  required,
  email,
  minLength,
  maxLength,
  sameAs
} from 'vuelidate/lib/validators'

export default function form($form) {  
  return {
    data () {
      return {
        sending: false,
        regex: {
          email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
          phone: /\(?([0-9]{3})\)?([ .-]?)([0-9]{3})\2([0-9]{4})/
        }
      }
    },
    mixins: [
      validationMixin
    ],
    validations: {
      form: setForm($form)
    },
    methods: {
      validateForm () {
        this.$v.$touch()
        if (!this.$v.$invalid) {
          return true
        } else {
          return false
        }
      },
      clearForm () {
        this.$v.$reset()
        this.form.email = null,
        this.form.username = null,
        this.form.telephone = null,
        this.form.firstname = null,
        this.form.lastname = null,
        this.form.password = null,
        this.form.mpassword = null,
        this.form.activation = null,
        this.form.code = null
      },
      getValidationClass (fieldName) {
        const field = this.$v.form[fieldName]
        if (field) {
          return {
            'md-invalid': field.$invalid && field.$dirty
          }
        }
      },
      checkUserName (val) {       
        const email = this.regex.email;
        const phone = this.regex.phone;
        if(email.test(String(val).toLowerCase())) {
          this.showTelephone = true
          this.showEmail = false
          this.showPrefix = false
          this.form.activation = "mail"
          this.form.email = this.form.username
        }
        else if(phone.test(String(val).toLowerCase())) {
          this.showTelephone = false
          this.showEmail = true
          this.showPrefix = true
          this.form.activation = "phone"
          this.form.telephone = this.form.username
        }
        else {
          this.showTelephone = false
          this.showEmail = false
          this.showPrefix = false
          this.form.activation = "mail"
        }
      },      
    }  
  }
}


//////////////////
// WEBPACK FOOTER
// ../nonameapp-common-modules/src/mixins/form.js
// module id = null
// module chunks = 